export const FORM_FIELD = {
  ATHLETES: {
    name: 'athleteIds',
    label: 'Athletes',
    rules: [{ min: 1, max: 4 }],
    serialize: (field, values) => ({
      [field.name]: values[field.name].map(({ id }) => id),
    }),
  },
};

export const FORM_FIELDS = Object.values(FORM_FIELD);

export const INITIAL_VALUES = {
  [FORM_FIELD.ATHLETES.name]: [],
};
